import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import AppShell from './AppShell';
import { API_BASE } from '../config/api';
import './PaymentResult.css';

export default function PaymentSuccess() {
    const location = useLocation();
    const navigate = useNavigate();

    const params = new URLSearchParams(location.search);
    const billId = params.get('billId') || params.get('id');
    const orderCode = params.get('orderCode');

    const [state, setState] = useState(billId ? 'loading' : 'ok');
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!billId) return;
        let alive = true;
        (async () => {
            try {
                await axios.put(`${API_BASE}/bill/editStatusBillConFirmPayment/${billId}`, {
                    status: 'Đã thanh toán',
                });
                if (alive) setState('ok');
            } catch (err) {
                console.error('Không cập nhật được trạng thái đơn:', err);
                if (alive) {
                    setError('Thanh toán đã được ghi nhận nhưng chưa cập nhật được trạng thái đơn. Tiệm sẽ kiểm tra lại giúp bạn.');
                    setState('ok');
                }
            }
        })();
        return () => { alive = false; };
    }, [billId]);

    return (
        <AppShell title="Thanh toán" back onBack={() => navigate('/')} tabbar={false} head={false}>
            <div className="shell">
                <div className="result-wrap">
                    {state === 'loading' ? (
                        <>
                            <div className="result-icon busy"><i className="fa-solid fa-spinner spin" /></div>
                            <h1 className="result-title">Đang xác nhận...</h1>
                            <p className="result-text">Tiệm đang ghi nhận thanh toán của bạn, chờ một chút nhé.</p>
                        </>
                    ) : (
                        <>
                            <div className="result-icon ok"><i className="fa-solid fa-check" /></div>
                            <h1 className="result-title">Thanh toán thành công!</h1>
                            {orderCode && <div className="result-code">#{orderCode}</div>}
                            <p className="result-text">
                                {error || 'Cảm ơn bạn đã đặt bánh. Bếp sẽ chuẩn bị và giao đúng ngày, đúng khung giờ bạn đã hẹn.'}
                            </p>
                            <div className="result-actions">
                                <Link to="/my-orders" className="btn btn-primary btn-block">Theo dõi đơn hàng</Link>
                                <Link to="/" className="btn btn-quiet btn-block">Về trang chủ</Link>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </AppShell>
    );
}
